import { useAuth } from '@teko/auth-react';
import { useTenantConfig, useFeatureFlags } from 'contexts';
import dynamic from 'next/dynamic';
import { SmartComponentProps } from '@tempi/smart-activation';
import { SmartComponentProps as TekfaceSmartComponentProps } from '@tekface/smart-activation';

// lazy import
const SmartComponent = dynamic(() => import('@tempi/smart-activation'));
const TekfaceSmartComponent = dynamic(
  () => import('@tekface/smart-activation'),
);

type SmartComponentEnvType = SmartComponentProps<{}>['env'];

type TekfaceSmartComponentEnvType = TekfaceSmartComponentProps<{}>['env'];

export const SmartBanner = () => {
  const { getProcessEnv, smartActivationConfig } = useTenantConfig();
  const { user, loading: profileLoading } = useAuth();
  const { flags } = useFeatureFlags();

  const trackingAppId = getProcessEnv('TRACKER_APP_ID');
  const landingBuilderEnv = getProcessEnv('LANDING_BUILDER_ENV');
  const { appId, sessionPeriodMinutes } = smartActivationConfig || {};
  // user has to login before show smart banner
  const showSmartBanner = !profileLoading && appId;

  if (!showSmartBanner) return null;

  return flags.epic_ma_150 ? (
    <TekfaceSmartComponent
      configs={{
        appId,
        trackingAppId,
        iamId: user?.userId,
        sessionPeriodMinutes,
      }}
      env={landingBuilderEnv as TekfaceSmartComponentEnvType}
      flagsup={{ epic_ma_79: flags.epic_ma_79 }}
      track={
        flags.epic_ma_229
          ? (event: string, data?: object) => {
              window.track(event, data);
            }
          : undefined
      }
    />
  ) : (
    <SmartComponent
      env={landingBuilderEnv as SmartComponentEnvType}
      configs={{
        appId,
        trackingAppId,
        iamId: user?.userId,
        sessionPeriodMinutes,
      }}
    />
  );
};
